import {GridColDef} from '@mui/x-data-grid-pro';
import {ReviewStatusOneviewEnum} from '../../schema-types/globalTypes';
import {TempAccumulatorType, ReviewsByStage} from './types';
import {ReviewSummaryFragment} from '../../schema-types/ReviewSummaryFragment';
import {SaltusAny} from '../../utils/SaltusAny';

export const transformReviewsData = (
  advReviews: ReviewSummaryFragment[]
): ReviewsByStage => {
  const initialAccumulator: TempAccumulatorType = Object.values(
    ReviewStatusOneviewEnum
  ).reduce((acc, status) => {
    acc[status as ReviewStatusOneviewEnum] = [];
    return acc;
  }, {} as TempAccumulatorType);

  return advReviews.reduce<TempAccumulatorType>((acc, review) => {
    const status = review.reviewStatus;
    if (status) {
      acc[status].push(review);
    }
    return acc;
  }, initialAccumulator);
};

const dateComparator = (v1: SaltusAny, v2: SaltusAny) => {
  const date1 = v1 ? new Date(v1).getTime() : 0;
  const date2 = v2 ? new Date(v2).getTime() : 0;
  return date1 - date2;
};

const renderCellDate = (value: SaltusAny) => {
  return value ? new Date(value).toLocaleDateString() : 'N/A';
};

export const generateColumns = (currentStage: string): GridColDef[] => {
  const baseColumns: GridColDef[] = [
    {field: 'name', headerName: 'Review Name', width: 200, flex: 1},
    {
      field: 'accountName',
      headerName: 'Account Name',
      width: 200,
      flex: 1,
      valueGetter: (value, row) => row.account?.name || 'N/A',
    },
  ];

  const stageSpecificColumn: GridColDef =
    currentStage === 'PLANNED'
      ? {
          field: 'dateScheduled',
          headerName: 'Scheduled Review Date',
          width: 150,
          flex: 1,
          valueGetter: (value, row) =>
            row.dateScheduled ? new Date(row.dateScheduled) : 'N/A',
          renderCell: renderCellDate,
          sortComparator: dateComparator,
        }
      : currentStage === 'MEETING_BOOKED'
      ? {
          field: 'dateBooked',
          headerName: 'Meeting Booked Date',
          width: 150,
          flex: 1,
          valueGetter: (value, row) =>
            row.dateBooked ? new Date(row.dateBooked) : 'N/A',
          renderCell: renderCellDate,
          sortComparator: dateComparator,
        }
      : {
          field: 'reviewStatus',
          headerName: 'Review Status',
          width: 150,
          flex: 1,
          valueFormatter: (value: SaltusAny) => value.replace(/_/g, ' ').toLowerCase(),
        };

  return [...baseColumns, stageSpecificColumn];
};
